import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import Layout from 'components/Layout';
import Meta from 'components/Meta';
import Image from 'components/Image';
import ScrollDown from 'components/ScrollDown';
import SectionTestimonials from 'components/SectionTestimonials';
import SectionStats from 'components/SectionStats';
import SectionContact from 'components/SectionContact';
import FloatingText from 'components/FloatingText';

import { aboutTabs, solutionsStepsData } from 'utils/contentProvider';

import { AboutContainer } from 'styles/about';

const AboutPage = ({ path }) => {
  const [tab, setTab] = useState(0);

  function tabToggleHandler(e) {
    setTab(Number(e.target.dataset.id));
  }

  return (
    <>
      <Meta
        title="About ATC | Digital Solutions That Put Business First"
        description="ATC is a global IT services and solutions provider focusing on Project Management Trainings, Managed Services, Cloud Integration, & Digital Transformation."
      />
      <Layout lightTheme path={path}>
        <AboutContainer>
          <section>
            <div className="container">
              <div className="inner-hero-area">
                <ScrollDown dark />
                <div className="row">
                  <div className="col-md-8">
                    <h1>
                      About ATC
                      <span className="pink">.</span>
                    </h1>
                    <div className="inner-hero-content">
                      <p>
                        We partner with entrepreneurs and businesses to build
                        products that solve everyday problems through creative
                        use of technology.
                      </p>
                      <a
                        href="#more-about-us"
                        onClick={(e) => {
                          e.preventDefault();
                          if (typeof window !== 'undefined')
                            window.scrollb.scrollIntoView(
                              document.getElementById('more-about-us'),
                            );
                        }}
                        className="pink-btn"
                      >
                        <span>Learn More About Us</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <Image
            src="about/03-inclusiveness.jpg"
            alt="about atc"
            className="inner-banner-img"
          />

          <section>
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className="inner-txt-block">
                    <p>
                      ATC nurtures client efficiency not only through the custom
                      products we build for their organizations, but with the
                      automation opportunities we identify through expert
                      business analysis.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="inner-txt-block">
                    <p>
                      Whether a startup or enterprise, ATC builds custom
                      software from scratch, taking integration with existing
                      environments into account without compromising an
                      impeccable user-experience.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section id="more-about-us">
            <div className="inner-tab-area">
              <div className="inner-tab-brdr">
                <div className="container">
                  <ul className="inner-tabs-triggers d-flex">
                    <li className={tab === 0 ? 'active-tab' : ''}>
                      <button
                        type="button"
                        data-id={0}
                        onClick={tabToggleHandler}
                      >
                        Who We Are
                      </button>
                    </li>
                    <li className={tab === 1 ? 'active-tab' : ''}>
                      <button
                        type="button"
                        data-id={1}
                        onClick={tabToggleHandler}
                      >
                        How We Work
                      </button>
                    </li>
                    <li className={tab === 2 ? 'active-tab' : ''}>
                      <button
                        type="button"
                        data-id={2}
                        onClick={tabToggleHandler}
                      >
                        Our Vision
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="inner-tab-content-area">
                <div className="container">
                  <div className="row">
                    <div className="col-md-5">
                      <div className="tab-content">
                        <h3>{aboutTabs[tab].title}</h3>
                        <p>{aboutTabs[tab].excerpt}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <Image
                  type="background"
                  tag="div"
                  src="about/who-we-are.jpg"
                  className="tab-inner-img"
                  style={{ position: 'absolute' }}
                />
              </div>
            </div>
          </section>

          <SectionStats
            dark
            customCSS={`
              padding: 0 0 104px;
  
              @media only screen and (max-width: 767px) {
                padding: 0 0 54px;
              }
            `}
          />

          <section>
            <div className="founder-speak">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6 col-md-8">
                    <div className="founder-txt">
                      <h5>
                        I didn’t get into this business to change the world –
                        but that is what technology does, it changes everything.
                        It is incredibly exciting to see how our work helps
                        companies transform and achieve technology goals that
                        when we first started didn’t even exist.
                      </h5>
                      <div className="founder-txt--about">
                        <Image
                          src="about/tara-jose-co-owner-and-president.jpg"
                          alt="tara jose co-owner and president"
                          style={{
                            width: 60,
                            display: 'inline-block',
                            verticalAlign: 'middle',
                            marginRight: 25,
                          }}
                        />
                        Tara Jose, President
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Image
                type="background"
                src="about/world-vector.jpg"
                tag="div"
                className="founder-img"
                style={{
                  position: 'absolute',
                  backgroundPosition: 'left center',
                }}
              />
            </div>
          </section>

          <Image
            type="background"
            tag="section"
            src="about/our-solutions.jpg"
            className="black-bg principles-section"
          >
            <div className="container">
              <div className="principle-main">
                <h2 className="medium-heading" style={{ maxWidth: 600 }}>
                  Our principles
                  <span className="pink"> guide </span>
                  everything we do
                  <span className="pink">.</span>
                </h2>
              </div>
              <div className="row principles-row">
                {solutionsStepsData.about.map((i) => (
                  <div key={i.id} className="col-12 col-md-6 col-lg-4">
                    <h3>{i.title}</h3>
                    {i.excerpt}
                  </div>
                ))}
              </div>
            </div>
          </Image>

          <section className="black-bg">
            <div className="abt-second">
              <div className="container">
                <div className="pos-rel">
                  <FloatingText text="Passionate people with a singular goal of helping our clients win" />
                  <div className="row">
                    <div className="col-md-4 offset-md-1">
                      <div className="abt-second-img">
                        <Image src="home/industry-1.jpg" alt="industry" />
                      </div>
                    </div>
                    <div className="col-md-6 offset-md-1">
                      <div className="abt-second-desc">
                        <h2 className="medium-heading">
                          Creating a&nbsp;
                          <span className="pink">frictionless</span>
                          &nbsp;experience
                          <span className="pink">.</span>
                        </h2>
                        <p>
                          Meeting the demands of today’s consumer cannot be done
                          in a silo anymore. That’s why we take an integrated
                          solutions approach (ISA) to navigate the complex
                          environment of today’s infrastructure. Our ISA
                          approach takes into account the future needs of our
                          customers based on their current systems and industry
                          outlook. In-depth understanding of a company’s
                          environment best prepares them for the future and
                          gives competitive advantage.
                        </p>
                        <Link to="/solutions/" className="read-more-btn">
                          Learn More&nbsp;
                          <i className="far fa-long-arrow-right" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div className="abt-third">
              <Image
                type="background"
                tag="div"
                src="about/abt-third.jpg"
                className="abt-third--img"
                style={{ position: 'absolute' }}
              />
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-md-6 offset-md-6">
                    <div className="abt-third-desc">
                      <h2 className="medium-heading black-txt">
                        Exciting challenges lie ahead. Join our team
                        <span className="pink">!</span>
                      </h2>
                      <p>
                        We bring passionate people together with a singular goal
                        of helping our clients win by providing unparalleled
                        service and technology solutions.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section>
            <div className="container">
              <div className="join-us-main">
                <h2 className="medium-heading white-txt">
                  Does this sound like a team you’d like to join?
                </h2>

                <Link to="/careers/" className="pink-btn-big">
                  Apply Today
                </Link>
              </div>
            </div>
          </section>

          <SectionTestimonials />
          <SectionContact />
        </AboutContainer>
      </Layout>
    </>
  );
};

AboutPage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default AboutPage;
